import React, { useState } from 'react';
//Components
import Normal from './LlamadaNormal';
import Simple from './LlamadaSimple';
import Ubicacion from './Ubicacion';
//Material-UI
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Divider from '@material-ui/core/Divider';

export default function Tipo() {
    const [selectedTipo, setSelectedTipo] = useState('normal');

    return (
        <div className="tipo-step">
            <div className="tipo-step-radio">
                <FormControl component="fieldset">
                    <FormLabel component="legend" className="llamada-step-section-title">Tipo de llamada</FormLabel>
                    <RadioGroup
                        row
                        name="tipoDeLlamada"
                        value={selectedTipo}
                        onChange={e => setSelectedTipo(e.target.value)}
                    >
                        <FormControlLabel value="normal" control={<Radio color="primary" />} label="Normal" />
                        <FormControlLabel value="simple" control={<Radio color="primary" />} label="Simple a beeper" />
                    </RadioGroup>
                </FormControl>
            </div>

            <Divider className="tipo-step-divider" />

            <div className="tipo-step-config">
                {selectedTipo === 'normal' ? <Normal /> : <Simple />}
            </div>

            <Divider className="tipo-step-divider" />

            <div className="tipo-step-ubicacion">
                <p className="llamada-step-section-title">¿Desde dónde se puede levantar?</p>
                <Ubicacion />
            </div>
        </div>
    );
}
